<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :readonly="disabledEdit" :options="[{ type: 'alert', label: '알림 대상자 선택' }]" />

    <!--    위험성평가 정보-->
    <div class="my-4">
      <div>
        <h5><i class="dot"></i> {{$t('위험성평가 정보')}}</h5>
      </div>
    </div>
    <div class="writeGridContainer">
      <div>
        <div>{{$t('공종명')}}</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
        <ml-input v-else v-model="form.inputB_2" class="w-full flex-1" :readonly="board.readonly || disabledEdit" />
      </div>
      <div>
        <div>{{$t('작업내용')}}</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_3 }}</p>
        <ml-input v-else v-model="form.inputB_3" class="w-full flex-1" :readonly="board.readonly || disabledEdit" />
      </div>
      <div>
        <div>{{$t('평가일')}}</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
        <date-selector v-else class="w-full flex-1" v-model="form.inputB_4" :readonly="board.readonly || disabledEdit" />
      </div>

      <div>
        <div>{{$t('실시기간')}}</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_8 }} ~ {{ form.inputB_9 }}</p>
        <div v-else class="w-full flex-1" style="display: flex; align-items: center">
          <date-selector class="w-full" v-model="form.inputB_8" :readonly="board.readonly || disabledEdit" @change="checkDate(form.inputB_8)" />
          &nbsp;~&nbsp;
          <date-selector class="w-full" v-model="form.inputB_9" :readonly="board.readonly || disabledEdit" @change="checkDate(form.inputB_9)" />
        </div>
      </div>
      <div>
        <div>{{$t('예정공정표 첨부')}}</div>
        <p v-if="isPrint" class="print-input">
          {{ form.inputB_10.fileName }}
        </p>
        <file-uploader :readonly="board.readonly || disabledEdit" v-else v-model="form.inputB_10" class="w-full flex-1" />
      </div>
      <div>
        <div>
          <div class="flex center-flex">{{$t('평가마감일')}}
            <vx-tooltip
              :title="$t('평가마감일이란?')"
              :html="$t('총괄관리자가 평가마감일을<br>지정할 시, 지정일 이후로 문서<br>수정이 불가합니다.')"
              style="margin-left: 4px; display: flex; align-items: center; justify-content: center"
              position="top"
              delay=".1s"
            >
              <feather-icon icon="HelpCircleIcon" style="cursor: pointer; width: 16px" />
            </vx-tooltip>
          </div>
        </div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_11 }}</p>
        <date-selector v-else class="w-full flex-1" v-model="form.inputB_11" :readonly="board.readonly || getLevel !== 1" />
      </div>
    </div>

    <!--    위험성 평가표-->
    <table-risk-appraisal_5x4_miras
      ref="riskAppraisalTable"
      class="mt-5"
      :title="$t('위험성평가표')"
      :value="form.riskAppraisalList"
      @input="updateList"
      :isPrint="isPrint"
      :readonly="board.readonly || disabledEdit"
      :hide-code-number="true"
      :is-numbering="true"
      @ai-recommendation="handleAIRecommendation"
      @image-ai-recommendation="handleImageAIRecommendation"
    />

    <!-- 안전·보건관리자 검토의견 -->
    <table-risk-appraisal2_5x4 class="mt-5" :title="$t('안전·보건관리자 검토의견')" v-model="form.riskAppraisalList2" :isPrint="isPrint" :readonly="board.readonly || disabledEdit" />

    <!--    사진대지-->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="조치 전 사진" placeholder="신축현장 점검" />

    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoListAfter" :is-print="isPrint" :readonly="board.readonly" section-title="조치 후 사진" placeholder="신축현장 점검" />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly || disabledEdit"></file-upload-module>

    <!-- AI 위험요인 추천 팝업 -->
    <popup-a-i-risk-recommendation v-model="showAIRecommendationPopup" :request-data="getAIRequestData()" @cancel="handleAIRecommendationCancel" @selectComplete="handleAIRecommendationSelectComplete" />

    <!-- 이미지 기반 AI 위험요인 추천 팝업 -->
    <popup-a-i-image-risk-recommendation v-model="showImageAIRecommendationPopup" :request-data="getAIRequestData()" @cancel="handleImageAIRecommendationCancel" @selectComplete="handleImageAIRecommendationSelectComplete" />
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import PopupProjectSetting from "@/views/project/PopupProjectSetting.vue";
import MemberSelector from "@/components/selector/MemberSelector.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import FileUploader from "@/components/FileUploader.vue";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import TableInspect from "@/components/TableInspect.vue";
import TableEquipment from "@/components/TableEquipment.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
import TableRiskAppraisal from "@/components/TableRiskAppraisal.vue";
import FieldSelectModule from "@/views/modules/FieldSelectModule.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import TableRiskAppraisal2_5x4 from "@/components/TableRiskAppraisal_5x4/TableRiskAppraisal2_5x4.vue";
import PhotoUploadBeforeAfterTable from "@/views/modules/PhotoUploadBeforeAfterTable.vue";
import TableRiskAppraisal_5x4_miras from "@/components/TableRiskAppraisal_5x4/TableRiskAppraisal_5x4_miras.vue";
import PopupAIRiskRecommendation from "@/popup/PopupAIRiskRecommendation.vue";
import PopupAIImageRiskRecommendation from "@/popup/PopupAIImageRiskRecommendation.vue";

export default {
  components: {
    TableRiskAppraisal_5x4_miras,
    PhotoUploadBeforeAfterTable,
    PopupAIRiskRecommendation,
    PopupAIImageRiskRecommendation,
    TableRiskAppraisal2_5x4,
    PhotoUploadGridModule,
    TableRiskAppraisal,
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    postId() {
      return this.$route.params.postId;
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const proj of projects) {
          if (proj.id === this.projectId && proj.company.length > 0) {
            const path = proj.company[0].pivot.company_path;
            const lv = path.split("/").length - 1;
            return lv;
          }
        }
      }
    },
    disabledEdit() {
      if (this.getLevel === 1) {
        return false;
      }

      const currentDate = new Date();
      const targetDate = new Date(this.form.inputB_11);
      // 오늘 날짜와 타겟 날짜 비교
      if (targetDate < currentDate) {
        // 날짜가 같음
        if (currentDate.format("yyyy-MM-dd") === targetDate.format("yyyy-MM-dd")) {
          return false; //저장버튼보임
        }

        // 날짜가 지났음
        return true; //저장버튼숨김
      } else {
        // 날짜가 지나지 않았음
        return false; //저장버튼보임
      }
    },

    isPhotoListEqual() {
      if (this.form.photoList.length !== this.photoListBeforeAfter.length) {
        return false;
      }
      for (let i = 0; i < this.form.photoList.length; i++) {
        if (this.form.photoList[i] !== this.photoListBeforeAfter[i].이전사진) {
          return false;
        }
      }
      return true;
    },
    isPhotoListAfterEqual() {
      if (this.form.photoListAfter.length !== this.photoListBeforeAfter.length) {
        return false;
      }
      for (let i = 0; i < this.form.photoListAfter.length; i++) {
        if (this.form.photoListAfter[i] !== this.photoListBeforeAfter[i].이후사진) {
          return false;
        }
      }
      return true;
    },
  },
  watch: {
    "value": {
      important: true,
      deep: true,
      handler() {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (this.value[key]) {
            this.form[key] = this.value[key];
          }
        }
      },
    },
    "form": {
      important: false,
      deep: true,
      handler() {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (this.value[key]) {
            this.form[key] = this.value[key];
          }
        }

        this.form.summary = {
          정기위험성평가_사업장명: [],
          정기위험성평가_재해형태: [],
        };

        this.form.summary["정기위험성평가_사업장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        for (const data of this.form.riskAppraisalList) {
          this.form.summary["정기위험성평가_재해형태"].push({
            [data.input_3]: 1,
          });
        }

        this.$emit("input", this.form);
      },
    },
    "form.inputB_11": {
      immediate: true,
      deep: true,
      handler() {
        if (this.form.inputB_11 !== "") {
          if (this.disabledEdit) {
            this.$emit("saveButtonControl", false); //저장버튼숨김
            this.$emit("removeButtonControl", false); //삭제버튼숨김
          } else {
            this.$emit("saveButtonControl", true); //저장버튼보임
            this.$emit("removeButtonControl", true); //삭제버튼보임
          }
        }
      },
    },

    // 이전 데이터방식의 데이터를 불러오기 위함
    "form.photoList": {
      immediate: true,
      deep: true,
      handler() {
        if (this.form.photoList.length > 0) {
          if (!this.isPhotoListEqual) {
            const listLength = Math.max(this.form.photoList.length, this.form.photoListAfter.length);
            this.photoListBeforeAfter = [];
            for (let i = 0; i < listLength; i++) {
              console.log("list before", i, this.form.photoList[i] ? this.form.photoList[i] : {});
              this.photoListBeforeAfter.push({
                id: `list_${i}`,
                이전사진: this.form.photoList[i] ? this.form.photoList[i] : {},
                이후사진: this.form.photoListAfter[i] ? this.form.photoListAfter[i] : {},
              });
            }
          }
        }
      },
    },
    "form.photoListAfter": {
      immediate: true,
      deep: true,
      handler() {
        if (this.form.photoListAfter.length > 0) {
          if (!this.isPhotoListAfterEqual) {
            const listLength = Math.max(this.form.photoList.length, this.form.photoListAfter.length);
            this.photoListBeforeAfter = [];
            for (let i = 0; i < listLength; i++) {
              console.log("list after", i, this.form.photoListAfter[i] ? this.form.photoListAfter[i] : {});
              this.photoListBeforeAfter.push({
                id: `list_${i}`,
                이전사진: this.form.photoList[i] ? this.form.photoList[i] : {},
                이후사진: this.form.photoListAfter[i] ? this.form.photoListAfter[i] : {},
              });
            }
          }
        }
      },
    },
  },
  data() {
    return {
      inspectionTitle: "방파제",
      photoListBeforeAfter: [],
      showAIRecommendationPopup: false,
      showImageAIRecommendationPopup: false,
      form: {
        stdInfo: {},

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",
        inputB_8: "",
        inputB_9: "",
        inputB_10: {}, // file
        inputB_11: "",

        photoList: [],
        photoListAfter: [],
        fileList: [],
        riskAppraisalList: [],
        riskAppraisalList2: [],
        disasters: "",
      },
    };
  },
  methods: {
    translationMap() {
      const prefix = "위험성평가.정기 위험성평가 (MIRAS)";

      const translateData = {
        [`${prefix}.기본정보.회사명`]: this.form.stdInfo.field_name,
        [`${prefix}.기본정보.작성자이름`]: this.form.stdInfo.writer_name,
        [`${prefix}.기본정보.작성일`]: this.form.stdInfo.date,

        [`${prefix}.위험성평가 정보.공종명`]: this.form.inputB_2,
        [`${prefix}.위험성평가 정보.작업내용`]: this.form.inputB_3,

        [`${prefix}.위험성평가표`]: this.form.riskAppraisalList.map((item) => {
          return {
            '세부작업명': item.input_1,
            '현재 안전보건조치': item.input_5,
            '현재위험도 가능성': item.input_6,
            '현재위험도 중대성': item.input_7,
            '현재위험도 위험도': item.input_8,
            '위험감소대책': item.input_9,
            '개선후 위험도 가능성': item.input_11,
            '개선후 위험도 중대성': item.input_12,
            '개선후 위험도 위험도': item.input_13,
          }
        }),

        [`${prefix}.안전보건관리자 검토의견`]: this.form.riskAppraisalList2.map((item) => {
          return {
            '세부작업명': item.input1,
            '검토의견': item.input2,
            '검토의견 반영 위험도.가능성': item.input3,
            '검토의견 반영 위험도.중대성': item.input4,
            '검토의견 반영 위험도.위험도': item.input5,
            '검토자': item.input6,
            '비고': item.input7,
          }
        }),

        [`${prefix}.조치 전 사진`]: this.form.photoList.map((item) => {
          return {
            input: item.input,
          };
        }),
        [`${prefix}.조치 후 사진`]: this.form.photoListAfter.map((item) => {
          return {
            input: item.input,
          };
        }),
      };

      return translateData;
    },
    translate(translate) {
      const prefix = "위험성평가.정기 위험성평가 (MIRAS)";

      this.form.stdInfo.field_name = translate[`${prefix}.기본정보.회사명`];
      this.form.stdInfo.writer_name = translate[`${prefix}.기본정보.작성자이름`];
      this.form.stdInfo.date = translate[`${prefix}.기본정보.작성일`];

      this.form.inputB_2 = translate[`${prefix}.위험성평가 정보.공종명`];
      this.form.inputB_3 = translate[`${prefix}.위험성평가 정보.작업내용`];

      const riskAppraisalList = translate[`${prefix}.위험성평가표`];
      const _riskAppraisalList = JSON.parse(JSON.stringify(this.form.riskAppraisalList));
      for (let i=0; i<riskAppraisalList.length; i++) {
        _riskAppraisalList[i].input_1 = riskAppraisalList[i]['세부작업명'];
        _riskAppraisalList[i].input_5 = riskAppraisalList[i]['현재 안전보건조치'];
        _riskAppraisalList[i].input_6 = riskAppraisalList[i]['현재위험도 가능성'];
        _riskAppraisalList[i].input_7 = riskAppraisalList[i]['현재위험도 중대성'];
        _riskAppraisalList[i].input_8 = riskAppraisalList[i]['현재위험도 위험도'];
        _riskAppraisalList[i].input_9 = riskAppraisalList[i]['위험감소대책'];
        _riskAppraisalList[i].input_11 = riskAppraisalList[i]['개선후 위험도 가능성'];
        _riskAppraisalList[i].input_12 = riskAppraisalList[i]['개선후 위험도 중대성'];
        _riskAppraisalList[i].input_13 = riskAppraisalList[i]['개선후 위험도 위험도'];
      }
      this.$set(this.form, "riskAppraisalList", _riskAppraisalList);

      const riskAppraisalList2 = translate[`${prefix}.안전보건관리자 검토의견`];
      const _riskAppraisalList2 = JSON.parse(JSON.stringify(this.form.riskAppraisalList2));
      for (let i=0; i<riskAppraisalList2.length; i++) {
        _riskAppraisalList2[i].input1 = riskAppraisalList2[i]['세부작업명'];
        _riskAppraisalList2[i].input2 = riskAppraisalList2[i]['검토의견'];
        _riskAppraisalList2[i].input3 = riskAppraisalList2[i]['검토의견 반영 위험도.가능성'];
        _riskAppraisalList2[i].input4 = riskAppraisalList2[i]['검토의견 반영 위험도.중대성'];
        _riskAppraisalList2[i].input5 = riskAppraisalList2[i]['검토의견 반영 위험도.위험도'];
        _riskAppraisalList2[i].input6 = riskAppraisalList2[i]['검토자'];
        _riskAppraisalList2[i].input7 = riskAppraisalList2[i]['비고'];
      }
      this.$set(this.form, "riskAppraisalList2", _riskAppraisalList2);


      const photoList = translate[`${prefix}.조치 전 사진`];
      for (let i=0; i<photoList.length; i++) {
        photoList[i] = {...this.form.photoList[i], ...photoList[i]}
      }
      this.$set(this.form, "photoList", photoList);

      const photoListAfter = translate[`${prefix}.조치 후 사진`];
      for (let i=0; i<photoListAfter.length; i++) {
        photoListAfter[i] = {...this.form.photoListAfter[i], ...photoListAfter[i]}
      }
      this.$set(this.form, "photoListAfter", photoListAfter);
    },

    inputPhotoList(list) {
      this.form.photoList = list.map((item) => item.이전사진);
      this.form.photoListAfter = list.map((item) => item.이후사진);
    },
    updateList(list) {
      this.form.riskAppraisalList = list;

      this.form.disasters = "";
      for (const risk of this.form.riskAppraisalList) {
        const riskName = risk.input_3.replace("직접입력_", "");
        this.form.disasters += `${riskName} `;
      }
    },
    checkDate(input) {
      if (Date.parse(this.form.inputB_8) > Date.parse(this.form.inputB_9)) {
        if (input === this.form.inputB_8) {
          this.form.inputB_9 = this.form.inputB_8;
        } else {
          this.form.inputB_8 = this.form.inputB_9;
        }
      }
    },
    handleAIRecommendation() {
      // 필요한 데이터가 모두 입력되어 있는지 확인
      if (!this.form.stdInfo.field_name || !this.form.inputB_3) {
        this.$vs.notify({
          title: "입력 오류",
          text: "사업장명, 작업내용을 모두 입력해주세요.",
          color: "warning",
        });
        return;
      }

      this.showAIRecommendationPopup = true;
    },

    handleImageAIRecommendation() {
      this.showImageAIRecommendationPopup = true;
    },

    getAIRequestData() {
      return {
        사업장명: this.form.stdInfo.field_name,
        공종명: this.form.inputB_2,
        작업내용: this.form.inputB_3,
        소속명: this.form.stdInfo.department || "",
        부서명: this.form.stdInfo.section || "",
      };
    },

    handleAIRecommendationCancel() {
      this.showAIRecommendationPopup = false;
    },

    handleAIRecommendationSelectComplete(selectedData) {
      // selectedData는 [{ index, text }, ...] 형태
      // form.riskAppraisalList에 직접 추가
      selectedData.forEach((item, idx) => {
        const newRiskItem = {
          id: `ai_${Date.now()}_${idx}`, // 고유 ID 생성
          input_1: item.text, // 세부작업명
          input_2: "", // 유해위험요인 (AI가 추천한 텍스트)
          input_3: "", // 재해형태
          input_4: "", // 현재 위험성
          input_5: "", // 허용 가능 위험성
          input_6: "", // 위험성 결정
          input_7: "", // 개선대책
          input_8: "", // 개선 후 위험성
          input_9: "", // 개선 후 허용 가능성
          input_10: "", // 개선 후 위험성 결정
          // 필요에 따라 다른 필드들도 추가
        };

        this.form.riskAppraisalList.push(newRiskItem);
      });

      this.showAIRecommendationPopup = false;

      this.$vs.notify({
        title: "추가 완료",
        text: `${selectedData.length}개의 위험요인이 추가되었습니다.`,
        color: "success",
      });
    },

    handleImageAIRecommendationCancel() {
      this.showImageAIRecommendationPopup = false;
    },

    handleImageAIRecommendationSelectComplete(selectedData) {
      // selectedData는 { items: [...], indices: [...], analysisData: {...} } 형태
      const { items, analysisData } = selectedData;

      // form.riskAppraisalList에 직접 추가
      items.forEach((item, idx) => {
        const newRiskItem = {
          id: `image_ai_${Date.now()}_${idx}`, // 고유 ID 생성
          input_1: item, // 세부작업명 (AI가 분석한 위험요인 설명)
          input_2: "", // 유해위험요인
          input_3: "", // 재해형태
          input_4: "", // 현재 위험성
          input_5: "", // 허용 가능 위험성
          input_6: "", // 위험성 결정
          input_7: "", // 개선대책
          input_8: "", // 개선 후 위험성
          input_9: "", // 개선 후 허용 가능성
          input_10: "", // 개선 후 위험성 결정
          // 이미지 분석 관련 메타데이터 저장 (필요시)
          analysisSource: 'image_ai',
          contextInfo: (analysisData && analysisData.context) || {}
        };

        this.form.riskAppraisalList.push(newRiskItem);
      });

      this.showImageAIRecommendationPopup = false;

      this.$vs.notify({
        title: "이미지 분석 완료",
        text: `${items.length}개의 위험요인이 추가되었습니다.`,
        color: "success",
      });
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
